import { Inject, Injectable, forwardRef} from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';

import  { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';

import { HttpClient } from './http-client.service';

import { AuditLog, FiscalYear } from '../../entities';

import { Settings } from '../../settings';
import { ODataBuilder } from '../../utility/odata/odata-builder';
import { ODataComparer } from '../../utility/odata/odata-comparer';

@Injectable()
export class AuditLogService {
  private readonly headers:Headers = new Headers({ 'Content-Type': 'application/json' });
  private readonly options:RequestOptions = new RequestOptions({ headers: this.headers });

  private static readonly auditLogBaseUrl:string = `${Settings.apiUrl}/v1/AuditLogs`;

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

  getAuditLogs(): Promise<AuditLog[]> {

    let oDataBuilder: ODataBuilder = new ODataBuilder(AuditLogService.auditLogBaseUrl);

    oDataBuilder.orderBy("AuditDate", true);

    let goalUrl: string = oDataBuilder.toString();

    return this.http.get(goalUrl)
      .toPromise()
      .then(response => response.json().value);
  }

  getAuditLogsForClubGoals(clubNameOrRCIClubId:string, top:number, skip:number, fiscalYear:FiscalYear): Promise<any> {

    let auditLogUrl:string = `${AuditLogService.auditLogBaseUrl}/RCC.GetClubGoalLogs(ClubNameOrRCIClubId='${clubNameOrRCIClubId}')/?$filter=AuditDate ge ${fiscalYear.StartDate.toISOString()} and AuditDate le ${fiscalYear.EndDate.toISOString()} and Entity eq ${AuditLog.AuditEntityFullyQualifiedType}'ClubGoal' and AuditLogType eq ${AuditLog.AuditLogTypeFullyQualifiedType}'BusinessLayer'&$top=${top}&$skip=${skip}&$orderby=AuditDate desc&$count=true`; //&$top=${top}&skip=${skip}

    return this.http.get(auditLogUrl)
      .toPromise()
      .then(response => response.json());
  }

  getAuditLogsForClubProjects(clubNameOrRCIClubId:string, top:number, skip:number, fiscalYear:FiscalYear): Promise<any> {

    let auditLogUrl:string = `${AuditLogService.auditLogBaseUrl}/RCC.GetClubProjectLogs(ClubNameOrRCIClubId='${clubNameOrRCIClubId}')/?$filter=AuditDate ge ${fiscalYear.StartDate.toISOString()} and AuditDate le ${fiscalYear.EndDate.toISOString()} and Entity eq ${AuditLog.AuditEntityFullyQualifiedType}'ClubProject' and AuditLogType eq ${AuditLog.AuditLogTypeFullyQualifiedType}'BusinessLayer'&$top=${top}&$skip=${skip}&$orderby=AuditDate desc&$count=true`; //&$top=${top}&skip=${skip}

    return this.http.get(auditLogUrl)
      .toPromise()
      .then(response => response.json());
  }

  // MCM-1093 Get the audit logs for Club ratings
  getAuditLogsForClubRatings(clubNameOrRCIClubId:string, top:number, skip:number, fiscalYear:FiscalYear): Promise<any> {
    
        let auditLogUrl:string = `${AuditLogService.auditLogBaseUrl}/RCC.GetClubRatingLogs(ClubNameOrRCIClubId='${clubNameOrRCIClubId}')/?$filter=AuditDate ge ${fiscalYear.StartDate.toISOString()} and AuditDate le ${fiscalYear.EndDate.toISOString()} and Entity eq ${AuditLog.AuditEntityFullyQualifiedType}'ClubRating' and AuditLogType eq ${AuditLog.AuditLogTypeFullyQualifiedType}'BusinessLayer'&$top=${top}&$skip=${skip}&$orderby=AuditDate desc&$count=true`; //&$top=${top}&skip=${skip}
    
        return this.http.get(auditLogUrl)
          .toPromise()
          .then(response => response.json());
      }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/audit-log.service.ts